import React from 'react'
import SmallNavbar from '../components/common/SmallNavbar'
import NavTop from '../components/common/NavTop'
import HomeNav from '../components/home/HomeNav'
import Footer from '../components/common/Footer'
import ThanksComponent from '../components/common/ThanksComponent'

const ThanksPage = () => {
  return (
    <div>

      <SmallNavbar/>
      <NavTop/>
      <HomeNav/>

      <ThanksComponent/>

      <Footer/>

        
        
        
    </div>
  )
}

export default ThanksPage